import React, { useEffect, useState } from "react";
import SideModalcontainer from "../partials/sidemodalcontainer";
import Close from "../../assets/icons/close.svg";
import SearchInput from "../partials/searchinput";
import PrimaryBtn from "../partials/btn";
import { useRequestStore } from "../../data/stores/loggerStore";
import { apiCall } from "../../data/useFetcher";

const SelectFilterModal = ({ handleClose, onClick }) => {
	const Region = [
			{
				name: "Africa",
				children: [
					"Kampala Capital City Authority - Uganda",
					"Kampala Capital City Authority - Uganda",
					"Kampala Capital City Authority - Uganda",
				],
			},
			{
				name: "Americas",
				children: [
					"Kampala Capital City Authority - Uganda",
					"Kampala Capital City Authority - Uganda",
					"Kampala Capital City Authority - Uganda",
				],
			},
			{
				name: "Asia",
				children: [
					"Kampala Capital City Authority - Uganda",
					"Kampala Capital City Authority - Uganda",
					"Kampala Capital City Authority - Uganda",
				],
			},
			{
				name: "Europe",
				children: [
					"Kampala Capital City Authority - Uganda",
					"Kampala Capital City Authority - Uganda",
					"Kampala Capital City Authority - Uganda",
				],
			},
			{
				name: "Oceania",
				children: [
					"Kampala Capital City Authority - Uganda",
					"Kampala Capital City Authority - Uganda",
					"Kampala Capital City Authority - Uganda",
				],
			},
		],
		{ getDynamicLogger, regionCountry, countrySystemOwner }: any =
			useRequestStore(),
		[data, setData] = useState<any>(null);

	useEffect(() => {
		// getDynamicLogger({}, "countrySystemOwner");
		apiCall({
			type: "get",
			url: `/api/v1/data-system/manage-region-country?pagination=not`,
			getter: (d: any) => getDynamicLogger(d, "regionCountry"),
		});
	}, []);

	useEffect(() => {
		// if (!data?.country) return;
		// getDynamicLogger({}, "countrySystemOwner");
		apiCall({
			type: "get",
			url: `/api/v1/auth/user/manage-users?privilege=system owner${
				data?.country ? `&country=${data?.country}` : ""
			}&setupStatus=Assessment Complete`,
			getter: (d: any) => getDynamicLogger(d, "countrySystemOwner"),
		});
	}, [data?.country]);

	return (
		<div>
			<SideModalcontainer>
				<div className="relative flex flex-col h-full">
					{/* Header */}
					<div
						style={{
							borderBottom: "1px solid #D9D9D9",
						}}
						className="h-12 w-full px-4 flex justify-between items-center">
						<h5 className="text-base font-medium text-black">Filter By</h5>
						<img onClick={handleClose} src={Close} alt="close" />
					</div>

					{/* Scrollable Body */}
					<div className="flex-1 overflow-y-auto mt-6 px-4">
						<div>
							<h5 className="text-sm mb-4 font-medium text-black">
								Search Country
							</h5>
							<SearchInput placeholder="Search Country" />
							<div className="mt-3 space-y-5 px-2 overflow-y-auto max-h-72">
								{regionCountry?.docs
									?.find((it: any) => it?.category === "COUNTRY")
									?.data?.sort(
										(
											a: { title: { toString: () => string } },
											b: { title: { toString: () => any } }
										) => {
											// Compare the values of the specified key in a case-insensitive manner
											return a?.title
												?.toString()
												?.localeCompare(b?.title?.toString());
										}
									)
									?.map((it: any, idx: number) => (
										<div key={idx} className="flex gap-2 items-center">
											<input
												type="radio"
												name="country"
												id={`country${it?.title}`}
												className="size-5"
												style={{ border: "1px solid #AAB7C6" }}
												onChange={() =>
													setData(prev => {
														return { ...prev, country: it?.title };
													})
												}
												checked={data?.country === it?.title}
											/>
											<label
												htmlFor={`country${it?.title}`}
												className="text-sm text-[#0D0C2B] font-normal">
												{it.title}
											</label>
										</div>
									))}
							</div>
						</div>
						<div className="mt-8">
							<h5 className="text-sm mb-4 font-medium text-black">
								Search Organisation
							</h5>
							<SearchInput placeholder="Search Organisation" />
							<div className="mt-3 space-y-5 px-2  overflow-y-auto max-h-72">
								{countrySystemOwner?.docs
									?.sort(
										(
											a: {
												user: { organizationName: { toString: () => string } };
											},
											b: {
												user: { organizationName: { toString: () => string } };
											}
										) => {
											// Compare the values of the specified key in a case-insensitive manner
											return a?.user?.organizationName
												?.toString()
												?.localeCompare(b?.user?.organizationName?.toString());
										}
									)
									?.map((it: any, idx: number) => (
										<div key={idx} className="flex gap-2 items-center">
											<input
												type="radio"
												name="organization"
												id={`organization${it?._id}`}
												className="size-5"
												style={{ border: "1px solid #AAB7C6" }}
												onChange={() =>
													setData(prev => {
														return { ...prev, organization: it?._id };
													})
												}
												checked={data?.organization === it?._id}
											/>
											<label
												htmlFor={`organization${it?._id}`}
												className="text-sm text-[#0D0C2B] font-normal">
												{it?.user?.organizationName} - {it?.country}
											</label>
										</div>
									))}
							</div>
						</div>
					</div>

					{/* Fixed Footer */}
					<div className="px-4 py-4 border-t border-[#D9D9D9] bg-white grid grid-cols-2 gap-2">
						<button
							onClick={handleClose}
							className="main-shadow main-border h-11 bg-transparent text-es-gray-200 text-base font-medium">
							Go Back
						</button>
						<PrimaryBtn
							onClick={e => {
								e?.preventDefault();
								onClick(data);
							}}
							text="Continue"
							width="w-full"
						/>
					</div>
				</div>
			</SideModalcontainer>
		</div>
	);
};

export default SelectFilterModal;
